export class StringUtilities {

    public static camelize(str: string): string {
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match: string, index: number) {
            if (+match === 0) {
                return "";
            }
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    }

    public static trimWhiteSpace(str: string): string {
        return str.replace(/^\s+|\s+$/g, '');
    }

    public static trimLeadingZeros(str: string): string {
        return str.replace(/^0+/, '');
    }

    public static endsWith(str: string, searchStr: string, ...args: any[]) {
        const _toString = Object.prototype.toString;
        const thisStr = String(StringUtilities.checkObjectCoercible(str));
        if (_toString.call(searchStr) === '[object RegExp]') throw new TypeError('Cannot call method "endsWith" with a regex');
        searchStr = String(searchStr);
        const thisLen = thisStr.length;
        const posArg = args.length > 2 ? args[2] : undefined;
        const pos = posArg === undefined ? thisLen : StringUtilities.toInteger(posArg);
        const end = Math.min(Math.max(pos, 0), thisLen);
        return thisStr.slice(end - searchStr.length, end) === searchStr;
    }

    public static startsWith(str: string, searchStr: string, ...args: any[]) {
        const _toString = Object.prototype.toString;
        const thisStr = String(StringUtilities.checkObjectCoercible(str));
        if (_toString.call(searchStr) === '[object RegExp]') throw new TypeError('Cannot call method "startsWith" with a regex');
        searchStr = String(searchStr);
        const startArg = args.length > 2 ? args[2] : undefined;
        const start = Math.max(StringUtilities.toInteger(startArg), 0);
        return thisStr.slice(start, start + searchStr.length) === searchStr;
    }

    public static escapeRegExp(str: string): string {
        return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
    }

    public static formatString(string: string, args: any[]) {
        return string.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    }

    private static isFinite = function (value: number) {
        // 1. If Type(number) is not Number, return false.
        if (typeof value !== 'number') {
            return false;
        }
        // 2. If number is NaN, +∞, or −∞, return false.
        if (value !== value || value === Infinity || value === -Infinity) {
            return false;
        }
        // 3. Otherwise, return true.
        return true;
    }

    private static isNaN = function (o: number) {
        return o !== o;
    }

    private static checkObjectCoercible = (x: any) => {
        if (x == null) throw TypeError('Cannot call method on ' + x);
        return x;
    }

    private static isSign = function (x: string | number) {
        x = Number(x);

        if (x === 0 || isNaN(x)) {
            return x;
        }

        return x > 0 ? 1 : -1;
    };

    private static toInteger = (value: string) => {
        const number = +value;
        if (StringUtilities.isNaN(number)) return 0;
        if (number === 0 || !StringUtilities.isFinite(number)) return number;
        return StringUtilities.isSign(number) * Math.floor(Math.abs(number));
    }

    public static titelize(str: string): string {
        return str
                // insert a space between lower & upper
                .replace(/([a-z])([A-Z])/g, '$1 $2')
                // space before last upper in a sequence followed by lower
                .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
                // uppercase the first character of each word
                .replace(/(^|\s)[a-z]/g, function (s) { return s.toUpperCase(); })
    }
}

export class StringIdGenerator {
    _chars: string;
    _nextId: number[] = [];

    constructor(chars = 'abcdefghijklmnopqrstuvwxyz') {
        this._chars = chars;
        this._nextId = [0];
    }

    next() {
        const r = [];
        for (const char of this._nextId) {
            r.unshift(this._chars[char]);
        }
        this._increment();
        return r.join('');
    }

    _increment() {
        for (let i = 0; i < this._nextId.length; i++) {
            const val = ++this._nextId[i];
            if (val >= this._chars.length) {
                this._nextId[i] = 0;
            } else {
                return;
            }
        }
        this._nextId.push(0);
    }

    *[Symbol.iterator]() {
        while (true) {
            yield this.next();
        }
    }
}
